import { CheckboxOption } from '@domgen/dgx-fe-forms/checkbox';

export const mockApplianceDetailsAdditionalAppliancesOptions: CheckboxOption[] =
  [
    {
      label: 'Washing Machine',
      checkboxValue: 'A-',
    },
    {
      label: 'Fridge Freezer',
      checkboxValue: 'F=',
    },
    {
      label: 'Dishwasher',
      checkboxValue: 'DW',
    },
    {
      label: 'Washer Dryer',
      checkboxValue: 'W-',
    },
    {
      label: 'Fridge',
      checkboxValue: 'R-',
    },
    {
      label: 'Oven',
      checkboxValue: 'O-',
    },
  ];
